// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import type Enums from '../Enums';

export class UpdateTenantSettingsRequest {
  readonly locationAutoSelect?: boolean | null;
  readonly targetMarginPercentage?: string | null;
  readonly minimumMarginPercentage?: string | null;
  readonly targetMarginFlatAmount?: string | null;
  readonly minimumMarginFlatAmount?: string | null;
  readonly marginConfiguration?: Enums.MarginConfiguration | null;
  readonly tierPricing?: boolean | null;
  readonly defaultCc?: string[];
  readonly defaultBcc?: string[];
  readonly setEmailDefaults?: boolean;
  readonly defaultQuoteValidityDays?: number | null;
  readonly defaultProjectValidityDays?: number | null;
  readonly defaultProjectBidDateDays?: number | null;
  readonly inheritQuoteExpirationFromProject?: boolean | null;
  readonly restrictActivityEditingToAssignees?: boolean | null;
  readonly approvalLadderMode?: Enums.QuoteApprovalLadderMode | null;
  readonly setProjectDateDefaults?: boolean;
  readonly timezone?: string | null;
  readonly locale?: string | null;
  readonly defaultCurrencyCode?: Enums.CurrencyCode | null;
  readonly defaultDryVolumeUnit?: Enums.Unit | null;
  readonly defaultWetVolumeUnit?: Enums.Unit | null;
  readonly defaultLengthUnit?: Enums.Unit | null;
  readonly defaultAreaUnit?: Enums.Unit | null;
  readonly defaultWeightUnit?: Enums.Unit | null;
  readonly defaultStrengthUnit?: Enums.Unit | null;
  readonly defaultOtherUnit?: Enums.Unit | null;

  constructor(data: { [key: string]: any } = {}) {
    this.locationAutoSelect = data.locationAutoSelect;
    this.targetMarginPercentage = data.targetMarginPercentage;
    this.minimumMarginPercentage = data.minimumMarginPercentage;
    this.targetMarginFlatAmount = data.targetMarginFlatAmount;
    this.minimumMarginFlatAmount = data.minimumMarginFlatAmount;
    this.marginConfiguration = data.marginConfiguration;
    this.tierPricing = data.tierPricing;
    this.defaultCc = data.defaultCc ?? [];
    this.defaultBcc = data.defaultBcc ?? [];
    this.setEmailDefaults = data.setEmailDefaults;
    this.defaultQuoteValidityDays = data.defaultQuoteValidityDays;
    this.defaultProjectValidityDays = data.defaultProjectValidityDays;
    this.defaultProjectBidDateDays = data.defaultProjectBidDateDays;
    this.inheritQuoteExpirationFromProject = data.inheritQuoteExpirationFromProject;
    this.restrictActivityEditingToAssignees = data.restrictActivityEditingToAssignees;
    this.approvalLadderMode = data.approvalLadderMode;
    this.setProjectDateDefaults = data.setProjectDateDefaults;
    this.timezone = data.timezone;
    this.locale = data.locale;
    this.defaultCurrencyCode = data.defaultCurrencyCode;
    this.defaultDryVolumeUnit = data.defaultDryVolumeUnit;
    this.defaultWetVolumeUnit = data.defaultWetVolumeUnit;
    this.defaultLengthUnit = data.defaultLengthUnit;
    this.defaultAreaUnit = data.defaultAreaUnit;
    this.defaultWeightUnit = data.defaultWeightUnit;
    this.defaultStrengthUnit = data.defaultStrengthUnit;
    this.defaultOtherUnit = data.defaultOtherUnit;
  }

  static zero(): UpdateTenantSettingsRequest {
    const zeroValues: ExcludeMethodsDeep<UpdateTenantSettingsRequest> = {};
    return new UpdateTenantSettingsRequest(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type UpdateTenantSettingsRequestWireFormat = {
  locationAutoSelect?: boolean | null;
  targetMarginPercentage?: string | null;
  minimumMarginPercentage?: string | null;
  targetMarginFlatAmount?: string | null;
  minimumMarginFlatAmount?: string | null;
  marginConfiguration?: string | null;
  tierPricing?: boolean | null;
  defaultCc?: string[];
  defaultBcc?: string[];
  setEmailDefaults?: boolean;
  defaultQuoteValidityDays?: number | null;
  defaultProjectValidityDays?: number | null;
  defaultProjectBidDateDays?: number | null;
  inheritQuoteExpirationFromProject?: boolean | null;
  restrictActivityEditingToAssignees?: boolean | null;
  approvalLadderMode?: string | null;
  setProjectDateDefaults?: boolean;
  timezone?: string | null;
  locale?: string | null;
  defaultCurrencyCode?: string | null;
  defaultDryVolumeUnit?: string | null;
  defaultWetVolumeUnit?: string | null;
  defaultLengthUnit?: string | null;
  defaultAreaUnit?: string | null;
  defaultWeightUnit?: string | null;
  defaultStrengthUnit?: string | null;
  defaultOtherUnit?: string | null;
};

type NewUpdateTenantSettingsRequestProps = PartialDeep<
  UpdateTenantSettingsRequest,
  { recurseIntoArrays: true }
>;
export const NewUpdateTenantSettingsRequest: (
  props: NewUpdateTenantSettingsRequestProps,
) => UpdateTenantSettingsRequest = (props) => new UpdateTenantSettingsRequest(props);

type NewUpdateTenantSettingsRequestFromWireFormatProps = PartialDeep<
  UpdateTenantSettingsRequestWireFormat,
  { recurseIntoArrays: true }
>;
export const NewUpdateTenantSettingsRequestFromWireFormat: (
  props: NewUpdateTenantSettingsRequestFromWireFormatProps,
) => UpdateTenantSettingsRequest = (props) => new UpdateTenantSettingsRequest(props);
